// import { FiGlobe, FiArrowDown } from "react-icons/fi";

// export default function Header() {
//   return (
//     <header className="relative overflow-hidden bg-gradient-to-br from-[#1a1a2e] via-[#2a2a3e] to-[#DA2128]/30 text-white">
//       <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(218,33,40,0.2),transparent_60%)]" />
//       <div className="absolute top-0 right-0 h-96 w-96 rounded-full bg-[#DB6400]/10 blur-3xl -mr-20 -mt-20" />
//       <div className="relative z-10 mx-auto max-w-7xl px-6 md:px-10 py-24 md:py-32">
//         <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
//           <div className="max-w-3xl">
//             <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-xs md:text-sm font-medium text-white/90 backdrop-blur-md border border-white/10 mb-6">
//               <FiGlobe className="h-4 w-4" /> ASSOCHAM — Apex Chamber of Commerce
//             </div>
//             <h1 className="font-['Cormorant_Garamond'] text-6xl md:text-[6.5rem] font-bold leading-[0.9] tracking-tight mb-6">
//               International <br />
//               <span className="italic font-normal text-[#F59C00]">Division</span>
//             </h1>
//             <p className="text-lg md:text-xl text-white/80 font-light leading-relaxed max-w-2xl">
//               Connecting Indian industry to global markets through strategic partnerships, trade missions, policy advocacy, and institutional collaboration.
//             </p>
//           </div>
//           <div className="flex-shrink-0">
//             {/* <a href="#switch-nav" className="inline-flex items-center gap-2 rounded-full bg-[#DA2128] text-white px-6 py-3 font-semibold text-sm shadow-2xl shadow-[#DA2128]/30 hover:bg-[#DB2628] transition-colors border border-white/10">
//               Explore Sections <FiArrowDown className="h-4 w-4" />
//             </a> */}
//           </div>
//         </div>
//       </div>
//       <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-[#FAF7F2] to-transparent" />
//     </header>
//   );
// }







// new new code 




import { FiGlobe, FiArrowDown, FiZap, FiCheckCircle } from "react-icons/fi";
import { motion } from "framer-motion";

export default function Header() {
  return (
   <header className="relative overflow-hidden bg-[#1a1a2e] text-white py-12 md:py-20 px-6 md:px-10 border-b border-gray-100/10">
  {/* Background Image with Dark Gradient Overlay (No Blur) */}
  <div 
    className="absolute inset-0 bg-cover bg-center bg-no-repeat"
    style={{ backgroundImage: "url('/International.jpg')" }}
  />
  <div className="absolute inset-0 bg-gradient-to-r from-[#1a1a2e]/90 via-[#1a1a2e]/75 to-[#1a1a2e]/60" />

  <div className="relative z-10 mx-auto max-w-7xl">
    <div className="grid lg:grid-cols-12 gap-8 items-center">
      
      {/* Main Hero Typography Column */}
      <motion.div 
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="lg:col-span-8 space-y-5"
      >
        {/* Top Pill Badge */}
        <div className="inline-flex items-center gap-2 rounded-full bg-black/40 px-3.5 py-1 text-xs font-medium text-white/90 border border-white/15 shadow-sm">
          <FiGlobe className="h-3.5 w-3.5 text-[#F59C00]" /> 
          <span>ASSOCHAM — Apex Chamber of Commerce</span>
        </div>

        {/* Header Heading */}
        <h1 className="font-['Cormorant_Garamond'] text-4xl sm:text-5xl md:text-6xl font-bold leading-[1.05] tracking-tight drop-shadow-md">
          International <span className="italic font-normal text-[#F59C00]">Division</span>
        </h1>

        {/* Subtext */}
        <p className="text-sm md:text-base text-white/90 font-light leading-relaxed max-w-2xl drop-shadow-sm">
          Connecting Indian industry to global markets through strategic partnerships, trade missions, policy advocacy, and institutional collaboration worldwide.
        </p>
      </motion.div>

      {/* Quick Stats Floating Card Column */}
      <motion.div 
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5, delay: 0.1 }}
        className="lg:col-span-4 grid sm:grid-cols-2 lg:grid-cols-1 gap-3"
      >
        <div className="rounded-2xl bg-[#1a1a2e]/85 border border-white/15 p-4 shadow-xl flex items-center gap-3.5">
          <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-[#DA2128] to-[#DB2628] flex items-center justify-center text-white shrink-0 font-bold text-base shadow-md">
            100+
          </div>
          <div>
            <div className="text-xs font-semibold text-white font-['Outfit']">Global Chamber Partners</div>
            <div className="text-[11px] text-white/70">Cross-border institutional MoUs</div>
          </div>
        </div>

        <div className="rounded-2xl bg-[#1a1a2e]/85 border border-white/15 p-4 shadow-xl flex items-center gap-3.5">
          <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-[#DB6400] to-[#F59C00] flex items-center justify-center text-white shrink-0 font-bold text-base shadow-md">
            50+
          </div>
          <div>
            <div className="text-xs font-semibold text-white font-['Outfit']">Commercial Missions</div>
            <div className="text-[11px] text-white/70">Annual delegations & summits</div>
          </div>
        </div>
      </motion.div>

    </div>
  </div>
</header>
  );
}